import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Typography } from "@mui/material";

const parseDateString = (dateString) => {
  if (typeof dateString !== "string" || !dateString.startsWith("new Date(")) {
    console.warn("Invalid date string:", dateString);
    return new Date();
  }
  try {
    const argsString = dateString.match(/new Date\((.*)\)/)?.[1];
    if (!argsString) return new Date();
    const args = argsString.split(",").map((arg) => parseInt(arg.trim(), 10));
    if (args.length < 3 || args.some(isNaN)) return new Date();
    return new Date(args[0], args[1], args[2], args[3] || 0, args[4] || 0, args[5] || 0);
  } catch (err) {
    console.error("Error parsing date string:", dateString, err);
    return new Date();
  }
};

const localizer = momentLocalizer(moment);

const Active_Bookings = ({ activeBookings, value }) => {
  const now = new Date();
  const currentDate = now.toISOString().split('T')[0]; // Current date in yyyy-mm-dd
  const isCurrentDate = value === currentDate;

  let minTime, maxTime, defaultDate;

  if (isCurrentDate) {
    // For current date, show from current time to 8 PM
    minTime = new Date();
    minTime.setHours(now.getHours(), 0, 0, 0);
    maxTime = new Date();
    maxTime.setHours(21, 0, 0, 0);
    defaultDate = new Date();
  } else {
    // For non-current date, show 8 AM to 8 PM
    defaultDate = new Date(value); // Parse value as date
    minTime = new Date(value);
    minTime.setHours(8, 0, 0, 0);
    maxTime = new Date(value);
    maxTime.setHours(20, 0, 0, 0);
  }

  const formattedBookings = activeBookings
    .map((booking) => {
      const startDate = parseDateString(booking.start);
      const endDate = parseDateString(booking.end);
      if (!startDate || !endDate) {
        console.warn("Skipping invalid booking:", booking);
        return null;
      }
      return {
        ...booking,
        title: `${booking.complete_event}`,
        start: startDate,
        end: endDate,
      };
    })
    .filter((booking) => booking !== null);

  const calendarStyles = `
    .rbc-time-view {
      background-color: white !important;
    }
    .rbc-time-content {
      background-color: white !important;
    }
    .rbc-time-slot {
      background-color: white !important;
    }
    .rbc-time-gutter {
      background-color: white !important;
    }
    .rbc-time-gutter .rbc-timeslot-group {
      background-color: white !important;
    }
    .rbc-day-bg {
      background-color: white !important;
    }
    .rbc-today {
      background-color: white !important;
    }
    .rbc-time-view .rbc-row {
      background-color: white !important;
    }
    .rbc-timeslot-group {
      min-height: 60px !important;
    }
  `;

  return (
    <>
      <style>{calendarStyles}</style>
      <div style={{ marginTop: "1rem" }}>
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 1 }}>
          Active Bookings
        </Typography>
        <div
          style={{
            margin: "0 auto",
            padding: "16px",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            backgroundColor: "white",
          }}
        >
          {isCurrentDate && now.getHours() >= 20 ? (
            <Typography variant="subtitle1" align="center" sx={{ color: "#555" }}>
              No active bookings after 8 PM.
            </Typography>
          ) : (
            <Calendar
              localizer={localizer}
              events={formattedBookings}
              defaultView="day"
              views={["day"]}
              defaultDate={defaultDate}
              min={minTime}
              max={maxTime}
              startAccessor="start"
              endAccessor="end"
              timeslots={1}
              step={60}
              showMultiDayTimes={false}
              toolbar={false}
              components={{
                timeGutterHeader: () => null,
                timeSlotWrapper: ({ children }) => <div>{children}</div>,
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Active_Bookings;